import { useParams, Link } from 'react-router-dom';
import TimeSeriesChart from '../../components/admin/TimeSeriesChart';
import PieChartCard from '../../components/admin/PieChartCard';
import useAdminData from './useAdminData';
import { fetchAgentDetail } from '../../services/adminStatsService';

export default function AdminAgentDetail() {
  const { id } = useParams();
  const { data, loading, error } = useAdminData((q) => fetchAgentDetail(id, q));

  if (loading) return <div className="text-gray-500">Loading…</div>;
  if (error) return <div className="text-red-600">{error}</div>;
  if (!data) return null;

  return (
    <div className="space-y-4">
      <Link to="/admin/agents" className="text-sm text-blue-600 hover:underline">
        ← Back to agents
      </Link>
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <h2 className="text-lg font-semibold">{data.user.name}</h2>
        <div className="text-sm text-gray-500">
          {data.user.email} · {data.user.role} · {(data.user.markets || []).join(', ')}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-white rounded-lg border border-gray-200 p-4">
          <h3 className="text-sm font-semibold text-gray-700 mb-2">Messages sent per day</h3>
          <TimeSeriesChart data={data.series || []} series={[{ key: 'messagesSent', label: 'Sent' }]} />
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4">
          <h3 className="text-sm font-semibold text-gray-700 mb-2">Conversations by status</h3>
          <PieChartCard data={data.byStatus || []} nameKey="status" valueKey="count" />
        </div>
      </div>
    </div>
  );
}
